export default {
  store: '商城',
  community: '社区',
  documents: '文档',
  developer: '开发者',
  admin: '管理者',
  message: '消息',
  language: '语言',
  work: '工单',
  lang: {
    english: 'EN 英文',
    chinese: 'CN 中文',
    japanese: 'JP 日语'
  },
  login: '登录',
  // 费用信息
  feeInfo: ['费用总览', '收支明细', '我的订单', '发票管理', '能力价格'],
  // 账户信息
  userInfo: {
    acountInfo: '我的账户',
    robot: '许可信息',
    operationLog: '操作日志',
    key: '我的Key',
    order: '我的订单',
    downloadApp: '我的应用',
    invoice: '开发票',
    cardP: '我的卡包',
    logOut: '退出'
  },
  'component.globalHeader.search': '站内搜索',
  'component.globalHeader.search.example1': '搜索提示一',
  'component.globalHeader.search.example2': '搜索提示二',
  'component.globalHeader.search.example3': '搜索提示三',
  'component.globalHeader.help': '使用文档',
  'component.globalHeader.notification': '通知',
  'component.globalHeader.notification.empty': '你已查看所有通知',
  'component.globalHeader.message': '消息',
  'component.globalHeader.message.empty': '您已读完所有消息',
  'component.globalHeader.event': '待办',
  'component.globalHeader.event.empty': '你已完成所有待办',
  'component.noticeIcon.clear': '清空',
  'component.noticeIcon.cleared': '清空了',
  'component.noticeIcon.empty': '暂无数据',
  'component.noticeIcon.view-more': '查看更多'
}
